import { ai } from './ai';
import { apiKeys } from './apiKeys';
import { audit } from './audit';
import { auth } from './auth';
import { banking } from './banking';
import { chats } from './chats';
import { common } from './common';
import { contacts } from './contacts';
import { dashboard } from './dashboard';
import { inbox } from './inbox';
import { keywords } from './keywords';
import { roles } from './roles';
import { logs } from './logs';
import { nav } from './nav';
import { notifications } from './notifications';
import { sessions } from './sessions';
import { settings } from './settings';
import { status } from './status';
import { users } from './users';
import { webhooks } from './webhooks';

/**
 * One flat key space, assembled from per-feature files.
 *
 * Flat because a nested dictionary buys nothing once keys are already
 * namespaced by prefix, and split across files because a single 1500-line
 * dictionary is a merge conflict waiting for the next person to add a screen.
 */
const NAMESPACES = [
  ai,
  apiKeys,
  audit,
  auth,
  banking,
  chats,
  common,
  contacts,
  dashboard,
  inbox,
  keywords,
  roles,
  logs,
  nav,
  notifications,
  sessions,
  settings,
  status,
  users,
  webhooks,
];

type Merged = typeof ai.en &
  typeof apiKeys.en &
  typeof audit.en &
  typeof auth.en &
  typeof banking.en &
  typeof chats.en &
  typeof common.en &
  typeof contacts.en &
  typeof dashboard.en &
  typeof inbox.en &
  typeof keywords.en &
  typeof roles.en &
  typeof logs.en &
  typeof nav.en &
  typeof notifications.en &
  typeof sessions.en &
  typeof settings.en &
  typeof status.en &
  typeof users.en &
  typeof webhooks.en;

export type MessageKey = keyof Merged;

export const DICTIONARY: Record<'en' | 'th', Record<MessageKey, string>> = {
  en: Object.assign({}, ...NAMESPACES.map((ns) => ns.en)),
  th: Object.assign({}, ...NAMESPACES.map((ns) => ns.th)),
};
